export const helpCenterLink = {
  counterOffer: {
    actions:
      "https://vcdn.student.com/prod-dashboard/Accept,%20Counter%20or%20Reject%20a%20student's%20order.mp4",
    deepDive:
      'https://vcdn.student.com/prod-dashboard/Deep%20dive%20into%20a%20Counter%20offer.mp4',
    editing: 'https://vcdn.student.com/prod-dashboard/Editing%20a%20Counter%20Offer.mp4',
  },
};
